import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Bell, BellOff } from "lucide-react";

const NOTIFY = ["MIXED_INDICATORS", "ESTIMATE_UPDATED", "DATA_UNAVAILABLE"];
const COOLDOWN_MS = 120000;

const beep = (up) => {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  [0, 0.18].forEach((d, i) => {
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.frequency.value = up ? 660 + i * 220 : 660 - i * 220;
    g.gain.setValueAtTime(0.2, ctx.currentTime + d);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + d + 0.16);
    o.connect(g).connect(ctx.destination);
    o.start(ctx.currentTime + d);
    o.stop(ctx.currentTime + d + 0.17);
  });
};

export const useSignalAlerts = (live) => {
  const [on, setOn] = useState(() => localStorage.getItem("alerts") === "on");
  const last = useRef(null);
  const lastAt = useRef(0);
  useEffect(() => {
    if (!live) return;
    const key = `${live.market.slug}:${live.status}`;
    const due = Date.now() - lastAt.current > COOLDOWN_MS;
    if (on && NOTIFY.includes(live.status) && last.current && last.current !== key && due) {
      lastAt.current = Date.now();
      toast(`Status: ${live.status_label}`, { description: live.explanation, duration: 12000 });
      beep(true);
      if ("Notification" in window && Notification.permission === "granted") new Notification(`PolyPulse: ${live.status_label}`, { body: live.explanation });
    }
    last.current = key;
  }, [live, on]);

  const toggle = async () => {
    const next = !on;
    if (next && "Notification" in window && Notification.permission === "default") await Notification.requestPermission();
    if (next) beep(true);
    localStorage.setItem("alerts", next ? "on" : "off");
    setOn(next);
    toast.success(next ? "Alerts on — you'll hear a beep when the analytics status changes (max every 2 min)" : "Alerts off");
  };
  return { on, toggle };
};

export const AlertsButton = ({ on, toggle }) => (
  <button onClick={toggle} data-testid="alerts-toggle"
    className={`flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-semibold transition-colors ${on ? "border-[#22D3EE] text-[#22D3EE] bg-blue-500/10" : "border-[#1A2338] text-slate-400 hover:text-slate-200"}`}>
    {on ? <Bell className="w-4 h-4" /> : <BellOff className="w-4 h-4" />}
    {on ? "Alerts ON" : "Turn on alerts"}
  </button>
);
